import { Component, OnInit, Input, Output, EventEmitter, NgZone } from '@angular/core';
import { AccessibilityService } from '../../../services/accessibility.service';
import { AppService } from '../../../app.service';
import { SharedService } from '@flysas/payment';
import { Router } from '@angular/router';
import { ErrorService } from '../../error/error.service';
import { PaymentService } from '../payment.service';
import { BuywifiService } from '../../../services/buywifi.service';
import { APP_TRANSLATE } from '../../../app.translation.en';
import { Subscription } from 'rxjs/Subscription';
import { TravelersService } from '../../travelers/travelers.service';
import { HttpService } from '../../../services/http.service';
import { CheckoutReviewService } from '../services/checkout-review.service';
import { CartService } from '../../products/cart/cart.service';



@Component({
  selector: 'app-pay',
  templateUrl: './pay.component.html'
})
export class PayComponent implements OnInit {

  @Input() public wifiKey: number;
  @Input() public maxretryError: boolean;
  @Input() public price: number;
  @Output() openSasTnc: EventEmitter<any> = new EventEmitter();
  ccFilled: boolean;
  public showSasPaymentTnC = false;
  public showTandCErrorTooltip = false;
  public paymentTnC = false;
  private payCall: boolean;
  private dcpId = '';
  private validation: any;
  private paySubscription: Subscription;
  private saveCardCheck = false;
  private fullFillment = this.appService.ancFullFillment;
  private loaderTextList = { loaderHeaderText: APP_TRANSLATE.paymentLoaderText, loaderSubHeaderText: '' };
  public sasTnC: any;
  showSasTnC = false;
  selectedGroup: string;
  selectedMethod: string;
  voucherCode: string;
  captchaValid: boolean;
  voucherExist: boolean;
  isVoucherEmptyErr: boolean;
  isVoucherValidationErr: boolean;
  giftCardAdded = false;
  addedVoucherAmount = [];
  vRedeem: boolean;
  giftCardTotal: number;
  showPaymentBtnLoader = false;

  constructor(private accessibilityService: AccessibilityService, private sharedService: SharedService,
    private appService: AppService, private buyWifiService: BuywifiService,
    private errorService: ErrorService, private paymentService: PaymentService, private router: Router,
    private travelersService: TravelersService,
    private httpService: HttpService,
    private reviewService: CheckoutReviewService,
    private cartService: CartService,
    private ngZone: NgZone) { }

  ngOnInit() {
    this.validation = {};
    this.validation.ccFormValid = false;
    this.validation.savedCard = false;
    this.validation.dcpId = '';
    this.getTnCData();
    this.paymentService.getLoaderPayBtn$.subscribe(value => {
      this.showPaymentBtnLoader = value;
    });
    this.paymentService.getIsGiftCardAdded$.subscribe(isGiftCard => {
      this.addedVoucherAmount = [];
      this.giftCardAdded = isGiftCard;
    });
    this.paymentService.getPaymentInfo$.subscribe(paymentInfo => {
      if (paymentInfo) {
        for (const payment of paymentInfo) {
          if (payment.type.toLowerCase() === 'vc') {
            this.addedVoucherAmount.push(
              {
                'amount': payment.value,
                'endsWith': '**' + payment.voucher.id.slice(-4)
              }
            );
          }
        }
      }

    });
    this.paymentService.getGiftCardTotal$.subscribe(total => {
      if (this.giftCardAdded) {
        this.giftCardTotal = total;
      }
    });

    this.sharedService.getPaymentOptionsResponse$.subscribe(paymentOptionsResponse => {
      if (paymentOptionsResponse) {
        this.paymentService.setMaxretryCountValue(paymentOptionsResponse);
      }
    });

    this.sharedService.getPaymentOptionsOutput$.subscribe(paymentOptionsOutput => {
      this.selectedGroup = paymentOptionsOutput.selectedGroup;
      //console.log("selectedGroup in payOninit", this.selectedGroup);
    });
    this.paymentService.updateCCFormError(false);
    if(document.getElementById("turi-float-btn")){
      document.getElementById("turi-float-btn").style.visibility= "hidden"
    }
  }

  getTnCData() {
    const tncUrls = this.travelersService.getTnCUrls();
    if (tncUrls) {
      this.httpService.getHtml(tncUrls.sas).subscribe(tncData => {
        this.sasTnC = tncData;
      })
    }
  }
  openSasPaymentTnC() {
    this.openSasTnc.emit();
    this.showSasTnC = true;
    this.accessibilityService.focus('#sasTnCAcc');
    return false;
  }

  closeSasTnCEvent() {
    this.showSasTnC = false;
  }

  optionChecked() {
    this.paymentTnC = !this.paymentTnC;
    if (this.paymentTnC) {
      this.showTandCErrorTooltip = false;
    } else {
      this.showTandCErrorTooltip = true;
    }
    this.accessibilityService.focus('#terms');
  }

  onTabFromtANDc(event) {
    event.preventDefault();
    event.stopPropagation();
    setTimeout(function () {
      this.accessibilityService.focus('.sasPaymentPayNowButton');
    }, 100);
  }

  proceedToConfirmation() {
    this.payCall = true;
    this.sharedService.getPaymentOptionsOutput$.subscribe(value => {
      // to check if there is a change in the selected group
      if (value.selectedGroup !== this.selectedGroup) {
        this.showTandCErrorTooltip = false;
      }
      this.selectedGroup = value.selectedGroup;
      this.dcpId = value.dcpId;
    });
    const disable = this.checkAllFieldsEntered() || this.checkVoucher();
    if (disable) {
      if (this.selectedGroup === 'CC' && !this.ccFilled) {
        this.sharedService.setCCError(true);
      }
    } else {
      this.sharedService.setCCError(false);
      this.sharedService.setCallCollect(false);
      this.sharedService.getPaymentOptionsOutput$.subscribe(value => {
        // to check if there is a change in the selected group
        this.selectedGroup = value.selectedGroup;
        this.dcpId = value.dcpId;
      });
      this.makeConfirmCall();
    }
  }

  makeConfirmCall() {
    if (this.paymentTnC && !this.showPaymentBtnLoader) {
      this.showTandCErrorTooltip = false;
      if (this.selectedGroup === 'CC' && this.paymentService.getCCFilled) {
        this.paymentService.updateCCFormError(!this.paymentService.getCCFilled);
        this.sharedService.setCallCollect(true);
        this.sharedService.getProceedPay$.subscribe(proceed => {
          if (proceed === true && this.payCall) {
            this.payCall = false;
            if (this.fullFillment) {
              this.confirmCall();
            } else {
              this.paymentCall();
            }
            this.payCall = false;
          }
        });
      } else if (this.selectedGroup === 'EBK') {
        this.confirmCall();
      }
    } else if (!this.paymentTnC) {
      this.showTandCErrorTooltip = true;
    }
  }


  confirmCall() {
    this.appService.showLoaderWithText(this.loaderTextList);
    const checkoutId = this.buyWifiService.getCheckOutId();
    this.paymentService.doCheckoutConfirmCall(checkoutId, this.dcpId, this.selectedGroup).subscribe(
      checkoutCallResponse => {
        this.reviewService.resetGiftCardDetails();
        this.paymentService.setConfirmTriggered(true);
        this.sharedService.setConfirmTriggered(true);
        this.checkoutFunction(checkoutCallResponse);
      },
      error => {
        this.getCallForErrors();
      }
    );
  }

  receivePaymentCallback($event) {
    this.validation = $event;
    this.dcpId = this.validation.dcpId;
    this.sharedService.getSaveCard$.subscribe(saveCard => {
      this.saveCardCheck = saveCard;
      this.paymentService.setSaveCardEnable(this.saveCardCheck);
    });
    this.saveCardCheck = this.validation.savedCard;
    if (this.saveCardCheck) {
      this.paymentService.setSaveCardEnable(true);

    }
  }

  checkoutFunction(checkoutCallResponse) {
    if (checkoutCallResponse && checkoutCallResponse.status === 'CNS') {
      this.buyWifiService.setReserveResponse({});
      this.doSavecardCall();
    } else {
      this.paymentService.setMaxretryLimit();
      this.setPayErrorResponse();
      this.doReleaseAndInitiateCall();
    }
  }
  doReleaseAndInitiateCall() {
    const checkoutId = this.buyWifiService.getCheckOutId();
    const noOfKeys = this.buyWifiService.getSessionValue();
    this.appService.showLoaderWithText(this.loaderTextList);
    this.cartService.doReleaseCall(checkoutId).subscribe(
      checkoutCallResponse => {
        this.cartService.initiateReserveCall(noOfKeys).subscribe(
          reserveCallResponse => {
            if (reserveCallResponse.status === 'RES') {
              this.router.navigate(['buywifi/payment']);
              this.buyWifiService.setReserveResponse(reserveCallResponse);
            } else if (reserveCallResponse.status === 'REF' || reserveCallResponse.status === 'FAILURE') {
              const errorCode = reserveCallResponse.notification[0].code;
              if (reserveCallResponse.notification && errorCode && errorCode.substring(0, 1) === '7') {
                const singleError = [];
                singleError.push(reserveCallResponse.notification[0].code);
                this.errorService.addError(singleError);
              } else {
                this.errorService.addError(this.buyWifiService.getDefaultError());
              }
            }
          }, error => {
            this.errorService.addError(this.buyWifiService.getDefaultError());
            this.appService.hideLoader();
            this.appService.hideLoaderWithText();
          });
      });
  }

  getCallForErrors() {
    this.reviewService.resetGiftCardDetails();
    this.paymentService.setConfirmTriggered(true);
    this.sharedService.setConfirmTriggered(true);
    this.paymentService.setMaxretryLimit();
    this.setPayErrorResponse();
    this.router.navigate(['buywifi/payment']);
    this.paymentService.viewDefaultError();
  }

  paymentCall() {
    this.appService.showLoaderWithText(this.loaderTextList);
    this.paymentService.doReserveCall(this.wifiKey).subscribe(
      reserveCallResponse => {
        if (reserveCallResponse.checkoutId) {
          this.paymentService.doCheckoutPayCall(reserveCallResponse.checkoutId, this.dcpId).subscribe(
            checkoutCallResponse => {
              if (checkoutCallResponse && checkoutCallResponse.status === 'SUCCESS') {
                this.doSavecardCall();
              } else {
                this.paymentService.setMaxretryLimit();
                this.setPayErrorResponse();
                this.router.navigate(['buywifi/payment']);
              }
            },
            error => {
              this.getCallForErrors();
            }
          );
        } else {
          this.setPayErrorResponse();
          this.paymentService.viewDefaultError();
        }
      },
      error => {
        this.setPayErrorResponse();
        this.paymentService.viewDefaultError();
      }
    );
  }

  doSavecardCall() {
    this.errorService.removeError();
    if (this.saveCardCheck) {
      this.sharedService.setCallAddOrUpdateCard(true);
    }
    this.appService.hideLoader();
    this.appService.hideLoaderWithText();
    this.ngZone.run(() => {
      this.router.navigate(['buywifi/confirmation']);
    });
  }

  setPayErrorResponse() {
    this.sharedService.setCallCollect(false);
    this.paymentTnC = false;
    const maxRetryData = this.paymentService.getMaxretryLimit();
    const maxRetryValue = this.paymentService.getMaxretryCountValue();
    if (maxRetryData !== 'null' && (maxRetryData) > maxRetryValue) {
      this.paymentService.setMaxRetryError(true);
      this.maxretryError = true;
    } else {
      this.paymentService.setPaymentInputData();
    }
  }

  checkVoucher(): boolean {
    let voucheralreadyAdded: boolean;
    this.sharedService.getVC.subscribe(vc => {
      this.voucherExist = vc;
    });
    if (this.sharedService.getcheckoutReviewRequest() && this.sharedService.getcheckoutReviewRequest().voucher
      && this.sharedService.getcheckoutReviewRequest().voucher.length > 0) {
      voucheralreadyAdded = false;
    } else {
      voucheralreadyAdded = true;
    }
    if (this.voucherExist && voucheralreadyAdded) {
      const voucherCodeRegex1 = RegExp(/^[a-zA-Z0-9]+$/);
      this.sharedService.getVoucherCode.subscribe(code => {
        this.voucherCode = code;
      });
      if (this.voucherCode === '') {
        this.isVoucherEmptyErr = true;
        this.sharedService.setVoucherEmptyError(true);
        return true;
      } else {
        const validateCode = voucherCodeRegex1.test(this.voucherCode);
        if (validateCode === false) {
          this.isVoucherValidationErr = true;
          this.sharedService.setVoucherValidationError(true);
          return true;
        } else {
          this.sharedService.getCaptcha.subscribe(valid => {
            this.captchaValid = valid;
          });
          if (!this.captchaValid) {
            return true;
          } else {
            this.sharedService.getVoucherRedeemed.subscribe(vRedeem => {
              this.vRedeem = vRedeem;
            });
            if (!this.vRedeem) {
              this.sharedService.setRedeemError(true);
              return true;
            }
          }
        }
      }
    } else {
      return false;
    }
    return false;
  }

  checkAllFieldsEntered(): boolean {
    let ccFilled = false;
    this.sharedService.getIsCcFormValid$.subscribe(value => {
      if (value === true) {
        ccFilled = true;
      }
    });
    if (this.selectedGroup === 'CC') {
      if (!ccFilled) {
        return true;
      }
    } else if (this.selectedGroup === undefined) {
      return true;
    } else {
      return false;
    }
    return false;
  }
  ngOnDestroy() {
    if (this.paySubscription) {
      this.paySubscription.unsubscribe();
    }
  }

}
